<template>
<section class="more">
  <el-dropdown size="mini" type="primary" @command="command">
    <el-link icon="iconfont iconcheck" type="text" size="small">更多</el-link>
    <el-dropdown-menu slot="dropdown">

      <template v-if="row.status==2">
        <el-dropdown-item command="bZhongzhi">终止</el-dropdown-item>
        <el-dropdown-item command="bShangbao">上报</el-dropdown-item>
        <el-dropdown-item command="bXiapai">下派</el-dropdown-item>
        <el-dropdown-item command="bZhipai">指派</el-dropdown-item>
        <el-dropdown-item command="bBohui">驳回</el-dropdown-item>
      </template>

      <template v-if="row.status==4">
        <el-dropdown-item command="bZhongzhi">终止</el-dropdown-item>
        <el-dropdown-item command="bXiapai">下派</el-dropdown-item>
        <el-dropdown-item command="bZhipai">指派</el-dropdown-item>
      </template>

      <template v-if="row.status==3">
        <el-dropdown-item command="bZhongzhi">终止</el-dropdown-item>
        <el-dropdown-item command="bXiapai">下派</el-dropdown-item>
        <el-dropdown-item command="bZhipai">指派</el-dropdown-item>
      </template>

      <template v-if="row.status==1">
        <el-dropdown-item command="bLingqu">待处理领取</el-dropdown-item>
      </template>

      <template v-if="row.status==0">
        <el-dropdown-item command="bZhongzhi">终止</el-dropdown-item>
        <el-dropdown-item command="bShangbao">上报</el-dropdown-item>
        <el-dropdown-item command="bXiapai">下派</el-dropdown-item>
        <el-dropdown-item command="bZhipai">指派</el-dropdown-item>
      </template>

      <template v-if="row.status==5">
        <el-dropdown-item command="bChuli">处理</el-dropdown-item>
      </template>

      <template v-if="row.status==6">
        <el-dropdown-item command="bLingqu">待验收领取</el-dropdown-item>
      </template>

      <template v-if="row.status==7">
        <el-dropdown-item command="bYanshou">验收</el-dropdown-item>
      </template>

      <!-- 
      <el-dropdown-item command="bZhongzhi">终止</el-dropdown-item>
      <el-dropdown-item command="bShangbao">上报</el-dropdown-item>
      <el-dropdown-item command="bXiapai">下派</el-dropdown-item>
      <el-dropdown-item command="bZhipai">指派</el-dropdown-item>
      <el-dropdown-item command="bXiapai">驳回</el-dropdown-item>
      <el-dropdown-item command="bChuli">处理</el-dropdown-item>
      <el-dropdown-item command="bYanshou">验收</el-dropdown-item>
       -->
    </el-dropdown-menu>
  </el-dropdown>
  <shangbao :row="row" :pVisible="visible.bShangbao" @cancel="function(){ visible.bShangbao=false;update();}"></shangbao>
  <xiapai :row="row" :pVisible="visible.bXiapai" @cancel="function(){visible.bXiapai=false; update();}"></xiapai>
  <zhipai :row="row" :pVisible="visible.bZhipai" @cancel="function(){visible.bZhipai=false; update();}"></zhipai>
  <bohui :row="row" :pVisible="visible.bBohui" @cancel="function(){visible.bBohui=false; update();}"></bohui>
  <zhongzhi :row="row" :pVisible="visible.bZhongzhi" @cancel="function(){visible.bZhongzhi=false; update();}"></zhongzhi>
  <chuli :row="row" :pVisible="visible.bChuli" @cancel="function(){visible.bChuli=false; update();}"></chuli>
  <yanshou :row="row" :pVisible="visible.bYanshou" @cancel="function(){visible.bYanshou=false; update();}"></yanshou>
  <bohui :row="row" :pVisible="visible.bBohui" @cancel="function(){visible.bBohui=false; update();}"></bohui>

</section>
</template>

<style scoped>
.el-dropdown {
  vertical-align: top;
}

.el-dropdown+.el-dropdown {
  margin-left: 15px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.more {
  text-align: left;
  display: inline;
}
</style>

<script>
import shangbao from './shangbao';
import xiapai from './xiapai';
import zhipai from './zhipai';
import bohui from './bohui';
import zhongzhi from './zhongzhi';
import chuli from './chuli';
import yanshou from './yanshou';
import {
  obj2urlsp
} from 'utils';
export default {
  props: {
    row: {

    }
  },
  data() {
    return {
      visible: {
        bShangbao: false,
        bXiapai: false,
        bZhipai: false,
        bBohui: false,
        bZhongzhi: false,
        bChuli: false,
        bYanshou: false,
        bLingqu: false
      }
    }
  },
  components: {
    shangbao,
    xiapai,
    zhipai,
    bohui,
    zhongzhi,
    chuli,
    yanshou
  },
  methods: {
    update() {
      this.$emit('update');
    },
    command(command) {
      this.$set(this.visible, command, true);
      if (command == 'bLingqu') {
        this.$axiospost('/operation/risk/update_status', obj2urlsp({
          ...this.form1,
          id: this.row.id,
          status: this.row.status == 1 ? 5 : 7,
          userAccount: localStorage.userAccount
        })).then(res => {
          this.$message({
            showClose: true,
            message: '领取成功',
            type: 'success'
          });
          this.update();
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/yinhuan/mine/more/index.vue